import type { FormContext } from "@custom-types/form-types";
import type { CargoOnboardParcelFormData } from "../add/schema/vesselNominationFormSchema";

export const TEST_ID_BASE = "pre-nomination-request";
export const LANG_BASE = "vessel-nomination.pre-nomination-request";
export const FIELDS_LANG_BASE = `${LANG_BASE}.fields`;

export const FORM_FIELDS = {
  VESSEL_ID: "vesselId",
  ETA: "eta",
  CALL_SIGN: "callSign",
  SUMMER_DWT: "summerDwt",
  ARRIVAL_DRAFT: "arrivalDraft",
  DEPARTURE_DRAFT: "departureDraft",
  HAS_HULL_PROTRUSION: "hasHullProtrusion",
  PARCELS: "parcels",
  REMARKS: "remarks",
  ATTACHMENTS: "attachments",
  CONFIRMATION: "confirmation",
} as const;

export type PreNominationRequestAttachment = {
  documentUrl?: string;
  documentType: string;
  otherSpecify: string;
  issueDate: Date | null;
  expirationDate: Date | null;
  documentName: string;
  documentSummary: string;
};

export const yesNoOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export type PreNominationRequestFormData = {
  [FORM_FIELDS.VESSEL_ID]: string;
  [FORM_FIELDS.ETA]: Date | null;
  [FORM_FIELDS.CALL_SIGN]: string;
  [FORM_FIELDS.SUMMER_DWT]?: string | number;
  [FORM_FIELDS.ARRIVAL_DRAFT]?: string | number;
  [FORM_FIELDS.DEPARTURE_DRAFT]?: string | number;
  [FORM_FIELDS.HAS_HULL_PROTRUSION]?: boolean | "";
  [FORM_FIELDS.PARCELS]: CargoOnboardParcelFormData[];
  [FORM_FIELDS.REMARKS]: string;
  [FORM_FIELDS.ATTACHMENTS]: PreNominationRequestAttachment[];
  [FORM_FIELDS.CONFIRMATION]: boolean;
};

export type PreNominationRequestOutletContext = Omit<
  FormContext<PreNominationRequestFormData>,
  "updateFormData"
> & {
  updateFormData: <K extends keyof PreNominationRequestFormData>(
    key: K,
    value: PreNominationRequestFormData[K],
  ) => void;
};

export type PreNominationRequestLabels = {
  eta: string;
  callSign: string;
  summerDwt: string;
  arrivalDraft: string;
  departureDraft: string;
  hasHullProtrusion: string;
  remarks: string;
  attachments: string;
  confirmation: string;
};

export const defaultValues: PreNominationRequestFormData = {
  [FORM_FIELDS.VESSEL_ID]: "",
  [FORM_FIELDS.ETA]: null,
  [FORM_FIELDS.CALL_SIGN]: "",
  [FORM_FIELDS.SUMMER_DWT]: undefined,
  [FORM_FIELDS.ARRIVAL_DRAFT]: undefined,
  [FORM_FIELDS.DEPARTURE_DRAFT]: undefined,
  [FORM_FIELDS.HAS_HULL_PROTRUSION]: "",
  [FORM_FIELDS.PARCELS]: [],
  [FORM_FIELDS.REMARKS]: "",
  [FORM_FIELDS.ATTACHMENTS]: [],
  [FORM_FIELDS.CONFIRMATION]: false,
};

export const ATTACHMENT_DOCUMENT_TYPES = [
  "CERTIFICATE",
  "PERMIT",
  "DOCUMENT",
  "INSURANCE",
  "VESSEL_MASTER_SOF",
  "OTHERS_SPECIFY",
] as const;

export const PRE_NOMINATION_REQUEST_UPLOAD_STORE_KEY = "preNominationRequestAttachments";

export const DocumentTypeOptions = [
  { label: "Certificate", value: ATTACHMENT_DOCUMENT_TYPES[0] },
  { label: "Permit", value: ATTACHMENT_DOCUMENT_TYPES[1] },
  { label: "Document", value: ATTACHMENT_DOCUMENT_TYPES[2] },
  { label: "Insurance", value: ATTACHMENT_DOCUMENT_TYPES[3] },
  { label: "Vessel Master-SoF", value: ATTACHMENT_DOCUMENT_TYPES[4] },
  { label: "Others-Specify", value: ATTACHMENT_DOCUMENT_TYPES[5] },
];
